// text: '工作台' 内部

const user = () => import('@/components/user/user'); //done
const changePhone = () => import('@/components/user/changePhone'); //done
const comReg = () => import('@/components/user/comReg'); //done
const viewMore = () => import('@/components/user/viewMore'); //done
const comJoin = () => import('@/components/user/comJoin'); //done
const changePassword = () => import('@/components/user/change-password'); //done





//规则添加
const ruleAdd = () => import('@/components/agreement/ruleAdd') //done
//规则设置
const setRule = () => import('@/components/agreement/setRule') //done
//意见征集
const disposeOpinion = () => import('@/components/agreement/disposeOpinion') //done
//意见处理
const ideaDispose = () => import('@/components/agreement/ideaDispose') //done
//预览
const preview = () => import('@/components/agreement/preview') //done
// 消息
const tidings = () => import('@/components/index/tidings')
//消息详情
// const message_detail = () => import('@/components/index/component/message/message_detail')


// 意见反馈
const opinionBack = () => import('@/components/feedback/opinionBack')
const workDetail = () => import('@/components/feedback/page/workDetail')
const operationManual = () => import('@/components/index/operationManual')
// 产品公告
const productBulletin = () => import('@/components/index/productBulletin')
const companyManagement = () => import('@/components/contract/company-management/company-management')
//知识库
const repository = () => import('@/components/repository/repository-box')

const officeApprove = () => import('@/components/officeAutomation/officeApprove/index'); //OA审批

const comRegC = () => import('@/components/user/comReg');
const adminInfoDetail = () => import('@/components/user/adminInfoDetail') //done
const noComInfoDetail = () => import('@/components/user/noComInfoDetail') //done
const comInfoDetail = () => import('@/components/user/comInfoDetail') //done
const modifyComInfo = () => import('@/components/user/modifyComInfo');

const noticeDetail = () => import('@/components/platform/contentManagement/notice/detail')
const versionDetail = () => import('@/components/platform/contentManagement/version/detail')
const versionProductDetail = () => import('@/components/index/versionDetail')
const frequentlyQuestion = () => import('@/components/index/frequentlyQuestion/index')



export default [{
    path: "/version/detail",
    name: "versionDetail",
    component: versionDetail,
    meta: {
      belong: ['none'],
      text: '版本详情'
    }
  },
  {
    path: "/versionProductDetail",
    name: "versionProductDetail",
    component: versionProductDetail,
    meta: {
      belong: ['none'],
      text: '版本详情'
    }
  },
  {
    path: "/notice/detail",
    name: "noticeDetail",
    component: noticeDetail,
    meta: {
      belong: ['none'],
      text: '公告详情'
    }
  },
  {
    path: "/frequentlyQuestion",
    name: "frequentlyQuestion",
    component: frequentlyQuestion,
    meta: {
      belong: ['none'],
      text: '常见问题'
    }
  },
  {
    path: '/modifyComInfo',
    name: 'modifyComInfo',
    meta: {
      belong: ['none'],
      text: '更新公司信息',
    },
    component: modifyComInfo
  },
  {
    path: '/comInfoDetail',
    name: 'comInfoDetail',
    meta: {
      belong: ['none'],
      text: '公司信息查看',
    },
    component: comInfoDetail
  },
  {
    path: '/adminInfoDetail',
    name: 'adminInfoDetail',
    meta: {
      belong: ['none'],
      text: '公司信息查看',
    },
    component: adminInfoDetail
  },
  {
    path: '/noComInfoDetail',
    name: 'noComInfoDetail',
    meta: {
      belong: ['none'],
      text: '公司信息查看',
    },
    component: noComInfoDetail
  },
  {
    path: '/adminInfoDetail',
    name: 'adminInfoDetail',
    meta: {
      belong: ['none'],
      text: '公司信息查看',
    },
    component: adminInfoDetail
  },
  {
    path: '/user/comReg',
    name: 'comRegC',
    meta: {
      belong: ['none'],
      text: '注册公司信息',
    },
    component: comRegC
  },
  {
    path: '/companyManagement',
    name: 'companyManagement',
    meta: {
      belong: ['none'],
      text: '公司管理',
    },
    component: companyManagement
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    meta: {
      belong: ['none'],
      text: '修改密码',
    },
    component: changePassword
  },
  {
    path: '/user/viewMore',
    name: 'viewMore',
    meta: {
      belong: ['none'],
      noStore: true,
    },
    component: viewMore
  }, {
    path: '/user/comJoin',
    name: 'comJoin',
    meta: {
      belong: ['none'],
      text: '加入已有公司',
    },
    component: comJoin
  },
  {
    path: '/changePhone',
    name: 'changePhone',
    meta: {
      belong: ['none'],
      text: '手机修改',
    },
    component: changePhone
  },
  {
    path: '/user',
    name: 'user',
    redirect: '/user/info',
    meta: {
      belong: ['none'],
      text: '个人设置',
    },
    component: user,
    children: [{
        path: 'info',
        name: 'userInfo',
        meta: {
          belong: ['none'],
          text: '基本信息',
        },
        component: resolve => {
          require(['@/components/user/components/info'],
            resolve)
        },
      },
      {
        path: 'account',
        name: 'userAccount',
        meta: {
          belong: ['none'],
          text: '收款账号',
        },
        component: resolve => {
          require(['@/components/user/components/account'],
            resolve)
        },
      }
    ]
  },

  // 操作手册
  {
    path: '/operationManual',
    name: 'operationManual',
    meta: {
      belong: ['none'],
      text: '操作手册',
    },
    component: operationManual,
  },
  // 产品公告
  {
    path: '/productBulletin',
    name: 'productBulletin',
    meta: {
      belong: ['none'],
      text: '产品公告',
    },
    component: productBulletin,
  },
  // 工单详情
  {
    path: '/workDetail',
    name: 'workDetail',
    meta: {
      belong: ['none'],
      noStore: true,
    },
    component: workDetail,
  },
  // 意见反馈
  {
    path: '/opinionBack',
    component: opinionBack,
    children: [{
        meta: {
          belong: ['none'],
          text: '意见反馈',
        },
        path: "opinionF",
        name: 'opinionF',
        component: resolve => {
          require(['@//components/feedback/page/opinionF.vue'], resolve)
        },
      },
      {
        meta: {
          belong: ['none'],
          text: '我的反馈',
        },
        path: "myFeedback",
        name: 'myFeedback',
        component: resolve => {
          require(['@//components/feedback/page/myFeedback.vue'], resolve)
        },
      }
    ]
  },
  {
    path: "/tidings",
    meta: {
      belong: ['none'],
      text: '消息中心',
    },
    name: 'tidings',
    component: tidings
  },
  //     {
  //     path: "/message_detail",
  //     meta: {
  //       belong: ['none'],
  //       text: '消息详情',
  //     },
  //     name: 'message_detail',
  //     component: message_detail
  //   },
  {
    path: '/preview',
    name: 'preview',
    meta: {
      belong: ['none'],
      text: '法律法规',
    },
    component: preview,
  },
  {
    path: '/ideaDispose',
    name: 'ideaDispose',
    meta: {
      belong: ['none'],
      text: '意见处理',
    },
    component: ideaDispose,
  },
  {
    path: '/disposeOpinion',
    name: 'disposeOpinion',
    meta: {
      belong: ['none'],
      text: '意见征集',
    },
    component: disposeOpinion,
  },
  {
    path: '/setRule',
    name: 'setRule',
    meta: {
      belong: ['none'],
      text: '协议设置',
    },
    component: setRule,
  },
  {
    path: '/ruleAdd',
    name: 'ruleAdd',
    meta: {
      belong: ['none'],
      text: '协议编辑',
    },
    component: ruleAdd,
  },
  {
    path: '/repository',
    name: 'repository',
    meta: {
      belong: ['none'],
      text: '知识库',
    },
    component: repository,
  },
  {
    path: 'officeApprove',
    name: 'officeApprove',
    meta: {
      belong: ['none'],
      text: 'OA审批',
    },
    component: officeApprove,
  },
]
